export const formattedDate = string => {
	const [ year, month, day ] = string.split('-');
	const date = `${day}.${month}.${year}`

	return date
}